export default {
  computed: {
    title() {
      return this.sectionTitle(this.section);
    },

    subtitle() {
      return this.sectionSubtitle(this.section);
    },

    initials() {
      let segments = this.title.trim().split(' ');

      if (segments.length > 1) {
        return (
          segments[0].split('')[0] + segments[segments.length - 1].split('')[0]
        );
      } else {
        return segments[0].split('')[0];
      }
    }
  },

  methods: {
    sectionTitle(section) {
      return section.speaker ? section.speaker.name : section.title;
    },

    sectionSubtitle(section) {
      return section.speaker
        ? [section.speaker.position, section.speaker.organisation]
            .filter(Boolean)
            .join(', ')
        : section.subtitle;
    }
  }
};
